import { render, staticRenderFns } from "./results_table_head.vue?vue&type=template&id=17a317fe&scoped=true&"
import script from "./results_table_head.vue?vue&type=script&lang=js&"
export * from "./results_table_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a317fe",
  null
  
)

export default component.exports